import { token } from '@atlaskit/tokens';

import { ComponentType } from '../edit/SmartButtonConfigPanel/templates/templateCardConfigs.tsx';

export const getBackgroundColor = (componentType: string) => {
	switch (componentType) {
		case ComponentType.TRIGGER:
			return 'color.background.accent.green.subtlest';
		case ComponentType.ACTION:
			return 'color.background.accent.blue.subtlest';
	}
};

export const getPrimaryColor = (componentType: string) => {
	switch (componentType) {
		case ComponentType.TRIGGER:
			return token('color.icon.accent.green');
		case ComponentType.ACTION:
			return token('color.icon.accent.blue');
	}
};

export const getTextColorByComponentType = (componentType: string) => {
	switch (componentType) {
		case ComponentType.TRIGGER:
			return 'color.text.success';
		case ComponentType.ACTION:
			return 'color.text.accent.blue';
	}
};
